import { render, staticRenderFns } from "./DefinitionTile.vue?vue&type=template&id=6a032184&"
import script from "./DefinitionTile.vue?vue&type=script&lang=js&"
export * from "./DefinitionTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports